import * as angular from 'angular';

angular
  .module('screeningcanvas')
  .filter('abs', function () {
    return function (input) {
      return Math.abs(input);
    };
  });
